import {IPrdictorStore} from "apps/BUDWEISERPOTM/modules/types/store";
import {createSelector} from "reselect";
import {RequestState} from "modules";

export const getVotesStore = (state: IPrdictorStore) => state.votes;

export const getVotes = createSelector(getVotesStore, (store) => store.votes);

export const getVoteByMatchId = createSelector([getVotesStore], (store) => (matchId: number) => {
	return store.votes[matchId];
});

export const getSelectedMatch = createSelector([getVotesStore], (store) => store.selectedMatchId);

export const getConfirmModalState = createSelector(
	[getVotesStore],
	(store) => store.confirmModalState
);

export const isVotesLoaded = createSelector(
	getVotesStore,
	(store) => store.requestState === RequestState.Received
);
